// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper[data-v-5f3f0401] {
  overflow-x: auto;
  overflow-y: hidden;
  min-height: 640px;
  display: flex;
  align-self: center;
  flex-direction: column;
}
.wrapper .custom[data-v-5f3f0401] {
  margin-top: 0;
  flex-basis: auto;
}
.wrapper .custom[data-v-5f3f0401] .main-content-container-main {
  margin-bottom: 0;
}
.wrapper .custom[data-v-5f3f0401] .spinner-cont {
  margin: 33% auto;
}
.calendar[data-v-5f3f0401] {
  background-color: var(--calendar-bg-color);
  min-height: 700px;
  font-size: 14px;
}
.calendar .calendar-header[data-v-5f3f0401] {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 800px;
  height: 40px;
}
.calendar .calendar-header .left-block[data-v-5f3f0401] {
  display: flex;
  align-items: center;
}
.calendar .calendar-header .left-block .month[data-v-5f3f0401] {
  font-size: 1.5em;
  color: var(--calendar-month-color);
  text-transform: capitalize;
}
.calendar .calendar-header .left-block .arrows[data-v-5f3f0401] {
  display: flex;
  font-size: 1.5em;
  color: var(--calendar-arrow-color);
  margin-right: 12px;
}
.calendar .calendar-header .left-block .arrows .arrow[data-v-5f3f0401] {
  margin: 0 0.5em;
}
.calendar .calendar-header .left-block .arrows .arrow[data-v-5f3f0401]:hover {
  cursor: pointer;
}
.calendar .calendar-header .right-block[data-v-5f3f0401] {
  display: flex;
  margin-top: 12px;
}
.calendar .calendar-header .right-block .btn-create-event[data-v-5f3f0401] {
  display: flex;
  align-items: center;
  font-size: 1.24em;
  margin-right: 12px;
  background-color: var(--calendar-header-btn-color);
  color: var(--bootstrap-btn-color);
  padding: 0 12px;
  line-height: 32px;
}
.calendar .calendar-header .right-block .btn-create-event[data-v-5f3f0401]:hover {
  background-color: var(--calendar-header-btn-hover-bg-color);
  cursor: pointer;
}
.calendar .calendar-header .right-block .btn-create-event .plus[data-v-5f3f0401] {
  font-size: 1.42em;
  margin-right: 6px;
}
.calendar .calendar-subheader[data-v-5f3f0401] {
  height: 22px;
}
.calendar .calendar-subheader .weekdays[data-v-5f3f0401] {
  display: grid;
  grid-template-columns: auto auto auto auto auto auto auto;
  margin-top: 1em;
  margin-bottom: 3px;
}
.calendar .calendar-subheader .weekdays .day[data-v-5f3f0401] {
  min-width: 112px;
  text-transform: capitalize;
  padding-left: 6px;
}
.calendar .calendar-body[data-v-5f3f0401] {
  position: relative;
  display: grid;
  grid-template-columns: auto auto auto auto auto auto auto;
}
.calendar .calendar-body .day[data-v-5f3f0401] {
  min-width: 112px;
  background-color: var(--calendar-day-bg-color);
  height: 9em;
  padding-top: 3px;
  padding-left: 6px;
  border-top: 1px solid var(--calendar-day-border-color);
}
.calendar .calendar-body .day .dayNumber[data-v-5f3f0401] {
  position: absolute;
  margin-left: 0;
  margin-top: 0;
}
.calendar .calendar-body .day.today[data-v-5f3f0401] {
  background-color: var(--calendar-today-bg-color);
}
.calendar .calendar-body .day.today[data-v-5f3f0401]:hover {
  margin-top: 0;
}
.calendar .calendar-body .day .today-line[data-v-5f3f0401] {
  border-bottom: 4px solid var(--calendar-today-border-color);
  position: relative;
  height: 4px;
  margin-top: -3px;
  margin-left: -6px;
  z-index: 99;
}
.calendar .calendar-body .day.notCurrentMonth[data-v-5f3f0401] {
  background-color: #6a6d701c;
}
.calendar .calendar-body .day.notCurrentMonth .dayNumber[data-v-5f3f0401] {
  color: var(--calendar-day-not-current-month-color);
}
.calendar .calendar-body .day.notCurrentMonth .events > .event[data-v-5f3f0401] {
  color: #508b4c;
}
.calendar .calendar-body .day .monthName[data-v-5f3f0401] {
  position: absolute;
  margin-left: 22px;
  color: var(--calendar-month-name-color);
}
.calendar .calendar-body .day[data-v-5f3f0401]:hover {
  cursor: pointer;
  background-color: var(--calendar-hover-bg);
  border: 1px solid var(--calendar-hover-border-color);
}
.calendar .calendar-body .day:hover .dayNumber[data-v-5f3f0401] {
  margin-left: -1px;
  margin-top: 0;
}
.calendar .calendar-body .day:hover .monthName[data-v-5f3f0401] {
  margin-left: 21px;
}
.calendar .calendar-body .day:hover .events[data-v-5f3f0401] {
  margin-top: 20px;
  margin-left: -1px;
}
.calendar .calendar-body .day:hover .eventsPanel[data-v-5f3f0401] {
  margin-left: -1px;
}
.calendar .calendar-body .day:hover .eventsPanel.lastDayOfWeek[data-v-5f3f0401],
.calendar .calendar-body .day:hover .eventsPanel.lastWeekOfMonth[data-v-5f3f0401] {
  margin-left: -111px;
}
.calendar .calendar-body .day .events[data-v-5f3f0401] {
  position: absolute;
  margin-top: 20px;
  margin-left: 0px;
  font-size: 10px;
  font-weight: 600;
  overflow-y: auto;
  max-height: 100px;
  width: 100px;
}
.calendar .calendar-body .day .events .event[data-v-5f3f0401] {
  display: flex;
  flex-direction: row;
  color: var(--calendar-event-color);
  border-bottom: 1px solid var(--calendar-event-bottom-border-color);
  padding-top: 1px;
}
.calendar .calendar-body .day .events .event[data-v-5f3f0401]:hover {
  background-color: var(--calendar-event-hover-bg);
}
.calendar .calendar-body .day .events .event .event-subject[data-v-5f3f0401] {
  margin-bottom: 0px;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 99%;
  white-space: nowrap;
}
.calendar .calendar-body .day .eventsPanel[data-v-5f3f0401] {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 210px;
  min-height: 72px;
  max-height: 188px;
  background-color: var(--calendar-events-bg);
  border: 1px solid var(--border-bottom-section);
  z-index: 999;
  filter: drop-shadow(2px 4px 6px black);
}
.calendar .calendar-body .day .eventsPanel .eventsPanelHeader[data-v-5f3f0401] {
  font-size: 12px;
  height: 40px;
  color: var(--bootstrap-btn-color);
  background-color: var(--calendar-events-panel-bg);
  display: flex;
  align-items: center;
  padding-left: 8px;
}
.calendar .calendar-body .day .eventsPanel .eventsPanelContent[data-v-5f3f0401] {
  min-height: 62px;
  background-color: var(--calendar-events-content-bg);
}
.calendar .calendar-body .day .eventsPanel .eventsPanelFooter[data-v-5f3f0401] {
  align-self: flex-start;
  background-color: var(--calendar-events-bg);
}
.calendar .calendar-body .day .eventsPanel .eventsPanelFooter[data-v-5f3f0401]:hover {
  cursor: default;
}
.calendar .calendar-body .day .eventsPanel .btn-edit-event[data-v-5f3f0401] {
  display: flex;
  align-items: center;
  background-color: var(--calendar-events-btn-bg);
  color: var(--bootstrap-btn-color);
  padding: 0 12px;
  margin-top: 6px;
  margin-left: 6px;
  margin-bottom: 6px;
  padding-top: 4px;
  padding-bottom: 4px;
}
.calendar .calendar-body .day .eventsPanel .btn-edit-event[data-v-5f3f0401]:hover {
  cursor: pointer;
  background-color: var(--calendar-events-btn-hover-bg);
}
.calendar .calendar-body .day .eventsPanel .btn-edit-event .plus[data-v-5f3f0401] {
  font-size: 1.2em;
  margin-right: 4px;
}
.calendar .calendar-body .day .eventsPanel .events-edit[data-v-5f3f0401] {
  margin-left: 0px;
  font-size: 10px;
  max-height: 104px;
  overflow-y: auto;
  padding-right: 1px;
  background-color: var(--calendar-edit-events-bg);
}
.calendar .calendar-body .day .eventsPanel .events-edit .event-edit[data-v-5f3f0401] {
  display: flex;
  flex-direction: row;
  font-weight: normal;
  line-height: 1.5em;
  margin-top: 4px;
}
.calendar .calendar-body .day .eventsPanel .events-edit .event-edit[data-v-5f3f0401]:hover {
  background-color: var(--calendar-edit-events-hover-bg);
}
.calendar .calendar-body .day .eventsPanel .events-edit .event-edit[data-v-5f3f0401]:before {
  position: relative;
  content: ' ';
  height: 30px;
  width: 0;
  border-left: 5px solid var(--calendar-edit-events-time-color);
  margin-left: 0px;
  margin-right: 12px;
}
.calendar .calendar-body .day .eventsPanel .events-edit .event-edit .event-time[data-v-5f3f0401] {
  display: flex;
  flex-direction: column;
  color: var(--calendar-edit-events-time-color);
}
.calendar .calendar-body .day .eventsPanel .events-edit .event-edit .event-subject[data-v-5f3f0401] {
  align-self: center;
  padding: 0 12px;
  color: var(--font-color);
}
.calendar .calendar-body .day .lastDayOfWeek[data-v-5f3f0401] {
  margin-left: -110px;
}
.calendar .calendar-body .day .lastWeekOfMonth[data-v-5f3f0401] {
  margin-top: -70px;
  margin-left: -110px;
}
.calendar .refresh[data-v-5f3f0401] {
  position: absolute;
  top: auto;
  bottom: auto;
  height: 100%;
  filter: opacity(0.5);
}
`, "",{"version":3,"sources":["webpack://./js/app/components/integrations/Calendar.vue"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kDAAkD;EAClD,iCAAiC;EACjC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,2DAA2D;EAC3D,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,yDAAyD;EACzD,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,yDAAyD;AAC3D;AACA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,sDAAsD;AACxD;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;AACA;EACE,gDAAgD;AAClD;AACA;EACE,aAAa;AACf;AACA;EACE,2DAA2D;EAC3D,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kDAAkD;AACpD;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,uCAAuC;AACzC;AACA;EACE,eAAe;EACf,0CAA0C;EAC1C,oDAAoD;AACtD;AACA;EACE,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,kEAAkE;EAClE,gBAAgB;AAClB;AACA;EACE,gDAAgD;AAClD;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;EAC3C,8CAA8C;EAC9C,YAAY;EACZ,sCAAsC;AACxC;AACA;EACE,eAAe;EACf,YAAY;EACZ,iCAAiC;EACjC,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,mDAAmD;AACrD;AACA;EACE,sBAAsB;EACtB,2CAA2C;AAC7C;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,+CAA+C;EAC/C,iCAAiC;EACjC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,qDAAqD;AACvD;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gDAAgD;AAClD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,sDAAsD;AACxD;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,QAAQ;EACR,6DAA6D;EAC7D,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,6CAA6C;AAC/C;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,oBAAoB;AACtB","sourcesContent":[".wrapper[data-v-5f3f0401] {\n  overflow-x: auto;\n  overflow-y: hidden;\n  min-height: 640px;\n  display: flex;\n  align-self: center;\n  flex-direction: column;\n}\n.wrapper .custom[data-v-5f3f0401] {\n  margin-top: 0;\n  flex-basis: auto;\n}\n.wrapper .custom[data-v-5f3f0401] .main-content-container-main {\n  margin-bottom: 0;\n}\n.wrapper .custom[data-v-5f3f0401] .spinner-cont {\n  margin: 33% auto;\n}\n.calendar[data-v-5f3f0401] {\n  background-color: var(--calendar-bg-color);\n  min-height: 700px;\n  font-size: 14px;\n}\n.calendar .calendar-header[data-v-5f3f0401] {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-width: 800px;\n  height: 40px;\n}\n.calendar .calendar-header .left-block[data-v-5f3f0401] {\n  display: flex;\n  align-items: center;\n}\n.calendar .calendar-header .left-block .month[data-v-5f3f0401] {\n  font-size: 1.5em;\n  color: var(--calendar-month-color);\n  text-transform: capitalize;\n}\n.calendar .calendar-header .left-block .arrows[data-v-5f3f0401] {\n  display: flex;\n  font-size: 1.5em;\n  color: var(--calendar-arrow-color);\n  margin-right: 12px;\n}\n.calendar .calendar-header .left-block .arrows .arrow[data-v-5f3f0401] {\n  margin: 0 0.5em;\n}\n.calendar .calendar-header .left-block .arrows .arrow[data-v-5f3f0401]:hover {\n  cursor: pointer;\n}\n.calendar .calendar-header .right-block[data-v-5f3f0401] {\n  display: flex;\n  margin-top: 12px;\n}\n.calendar .calendar-header .right-block .btn-create-event[data-v-5f3f0401] {\n  display: flex;\n  align-items: center;\n  font-size: 1.24em;\n  margin-right: 12px;\n  background-color: var(--calendar-header-btn-color);\n  color: var(--bootstrap-btn-color);\n  padding: 0 12px;\n  line-height: 32px;\n}\n.calendar .calendar-header .right-block .btn-create-event[data-v-5f3f0401]:hover {\n  background-color: var(--calendar-header-btn-hover-bg-color);\n  cursor: pointer;\n}\n.calendar .calendar-header .right-block .btn-create-event .plus[data-v-5f3f0401] {\n  font-size: 1.42em;\n  margin-right: 6px;\n}\n.calendar .calendar-subheader[data-v-5f3f0401] {\n  height: 22px;\n}\n.calendar .calendar-subheader .weekdays[data-v-5f3f0401] {\n  display: grid;\n  grid-template-columns: auto auto auto auto auto auto auto;\n  margin-top: 1em;\n  margin-bottom: 3px;\n}\n.calendar .calendar-subheader .weekdays .day[data-v-5f3f0401] {\n  min-width: 112px;\n  text-transform: capitalize;\n  padding-left: 6px;\n}\n.calendar .calendar-body[data-v-5f3f0401] {\n  position: relative;\n  display: grid;\n  grid-template-columns: auto auto auto auto auto auto auto;\n}\n.calendar .calendar-body .day[data-v-5f3f0401] {\n  min-width: 112px;\n  background-color: var(--calendar-day-bg-color);\n  height: 9em;\n  padding-top: 3px;\n  padding-left: 6px;\n  border-top: 1px solid var(--calendar-day-border-color);\n}\n.calendar .calendar-body .day .dayNumber[data-v-5f3f0401] {\n  position: absolute;\n  margin-left: 0;\n  margin-top: 0;\n}\n.calendar .calendar-body .day.today[data-v-5f3f0401] {\n  background-color: var(--calendar-today-bg-color);\n}\n.calendar .calendar-body .day.today[data-v-5f3f0401]:hover {\n  margin-top: 0;\n}\n.calendar .calendar-body .day .today-line[data-v-5f3f0401] {\n  border-bottom: 4px solid var(--calendar-today-border-color);\n  position: relative;\n  height: 4px;\n  margin-top: -3px;\n  margin-left: -6px;\n  z-index: 99;\n}\n.calendar .calendar-body .day.notCurrentMonth[data-v-5f3f0401] {\n  background-color: #6a6d701c;\n}\n.calendar .calendar-body .day.notCurrentMonth .dayNumber[data-v-5f3f0401] {\n  color: var(--calendar-day-not-current-month-color);\n}\n.calendar .calendar-body .day.notCurrentMonth .events > .event[data-v-5f3f0401] {\n  color: #508b4c;\n}\n.calendar .calendar-body .day .monthName[data-v-5f3f0401] {\n  position: absolute;\n  margin-left: 22px;\n  color: var(--calendar-month-name-color);\n}\n.calendar .calendar-body .day[data-v-5f3f0401]:hover {\n  cursor: pointer;\n  background-color: var(--calendar-hover-bg);\n  border: 1px solid var(--calendar-hover-border-color);\n}\n.calendar .calendar-body .day:hover .dayNumber[data-v-5f3f0401] {\n  margin-left: -1px;\n  margin-top: 0;\n}\n.calendar .calendar-body .day:hover .monthName[data-v-5f3f0401] {\n  margin-left: 21px;\n}\n.calendar .calendar-body .day:hover .events[data-v-5f3f0401] {\n  margin-top: 20px;\n  margin-left: -1px;\n}\n.calendar .calendar-body .day:hover .eventsPanel[data-v-5f3f0401] {\n  margin-left: -1px;\n}\n.calendar .calendar-body .day:hover .eventsPanel.lastDayOfWeek[data-v-5f3f0401],\n.calendar .calendar-body .day:hover .eventsPanel.lastWeekOfMonth[data-v-5f3f0401] {\n  margin-left: -111px;\n}\n.calendar .calendar-body .day .events[data-v-5f3f0401] {\n  position: absolute;\n  margin-top: 20px;\n  margin-left: 0px;\n  font-size: 10px;\n  font-weight: 600;\n  overflow-y: auto;\n  max-height: 100px;\n  width: 100px;\n}\n.calendar .calendar-body .day .events .event[data-v-5f3f0401] {\n  display: flex;\n  flex-direction: row;\n  color: var(--calendar-event-color);\n  border-bottom: 1px solid var(--calendar-event-bottom-border-color);\n  padding-top: 1px;\n}\n.calendar .calendar-body .day .events .event[data-v-5f3f0401]:hover {\n  background-color: var(--calendar-event-hover-bg);\n}\n.calendar .calendar-body .day .events .event .event-subject[data-v-5f3f0401] {\n  margin-bottom: 0px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 99%;\n  white-space: nowrap;\n}\n.calendar .calendar-body .day .eventsPanel[data-v-5f3f0401] {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 210px;\n  min-height: 72px;\n  max-height: 188px;\n  background-color: var(--calendar-events-bg);\n  border: 1px solid var(--border-bottom-section);\n  z-index: 999;\n  filter: drop-shadow(2px 4px 6px black);\n}\n.calendar .calendar-body .day .eventsPanel .eventsPanelHeader[data-v-5f3f0401] {\n  font-size: 12px;\n  height: 40px;\n  color: var(--bootstrap-btn-color);\n  background-color: var(--calendar-events-panel-bg);\n  display: flex;\n  align-items: center;\n  padding-left: 8px;\n}\n.calendar .calendar-body .day .eventsPanel .eventsPanelContent[data-v-5f3f0401] {\n  min-height: 62px;\n  background-color: var(--calendar-events-content-bg);\n}\n.calendar .calendar-body .day .eventsPanel .eventsPanelFooter[data-v-5f3f0401] {\n  align-self: flex-start;\n  background-color: var(--calendar-events-bg);\n}\n.calendar .calendar-body .day .eventsPanel .eventsPanelFooter[data-v-5f3f0401]:hover {\n  cursor: default;\n}\n.calendar .calendar-body .day .eventsPanel .btn-edit-event[data-v-5f3f0401] {\n  display: flex;\n  align-items: center;\n  background-color: var(--calendar-events-btn-bg);\n  color: var(--bootstrap-btn-color);\n  padding: 0 12px;\n  margin-top: 6px;\n  margin-left: 6px;\n  margin-bottom: 6px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n}\n.calendar .calendar-body .day .eventsPanel .btn-edit-event[data-v-5f3f0401]:hover {\n  cursor: pointer;\n  background-color: var(--calendar-events-btn-hover-bg);\n}\n.calendar .calendar-body .day .eventsPanel .btn-edit-event .plus[data-v-5f3f0401] {\n  font-size: 1.2em;\n  margin-right: 4px;\n}\n.calendar .calendar-body .day .eventsPanel .events-edit[data-v-5f3f0401] {\n  margin-left: 0px;\n  font-size: 10px;\n  max-height: 104px;\n  overflow-y: auto;\n  padding-right: 1px;\n  background-color: var(--calendar-edit-events-bg);\n}\n.calendar .calendar-body .day .eventsPanel .events-edit .event-edit[data-v-5f3f0401] {\n  display: flex;\n  flex-direction: row;\n  font-weight: normal;\n  line-height: 1.5em;\n  margin-top: 4px;\n}\n.calendar .calendar-body .day .eventsPanel .events-edit .event-edit[data-v-5f3f0401]:hover {\n  background-color: var(--calendar-edit-events-hover-bg);\n}\n.calendar .calendar-body .day .eventsPanel .events-edit .event-edit[data-v-5f3f0401]:before {\n  position: relative;\n  content: ' ';\n  height: 30px;\n  width: 0;\n  border-left: 5px solid var(--calendar-edit-events-time-color);\n  margin-left: 0px;\n  margin-right: 12px;\n}\n.calendar .calendar-body .day .eventsPanel .events-edit .event-edit .event-time[data-v-5f3f0401] {\n  display: flex;\n  flex-direction: column;\n  color: var(--calendar-edit-events-time-color);\n}\n.calendar .calendar-body .day .eventsPanel .events-edit .event-edit .event-subject[data-v-5f3f0401] {\n  align-self: center;\n  padding: 0 12px;\n  color: var(--font-color);\n}\n.calendar .calendar-body .day .lastDayOfWeek[data-v-5f3f0401] {\n  margin-left: -110px;\n}\n.calendar .calendar-body .day .lastWeekOfMonth[data-v-5f3f0401] {\n  margin-top: -70px;\n  margin-left: -110px;\n}\n.calendar .refresh[data-v-5f3f0401] {\n  position: absolute;\n  top: auto;\n  bottom: auto;\n  height: 100%;\n  filter: opacity(0.5);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
